var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t(("white-label.components.trendArrow." + _vm.orientation))))]),_c('div',{staticClass:"c-trend-arrow",class:[_vm.orientation]},[_c('i',{staticClass:"fas fa-caret-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }